<div *ngIf="text">
  <div *ngIf="text.length <= limit">{{text}}</div>
  <div *ngIf="truncating && text.length > limit" class="truncated-text__block">
    <div class="truncated-text__text">{{text | truncate : limit}}</div>
    <div class="truncated-text__button" (click)="truncating = false">Show more</div>
  </div>
  <div *ngIf="!truncating && text.length > limit" class="truncated-text__block">
    <div class="truncated-text__text">{{text}}</div>
    <div class="truncated-text__button" (click)="truncating = true">Show less</div>
  </div>
</div>
